import { Injectable, signal } from '@angular/core';
import { Filmstrip, Module } from '@ay-gosu-party/modules';
import { getModule } from '@ay-gosu-party/modules/modules';
import { recalcFilmstripIndex } from '@ay-gosu-party/modules/utils/recalc-filmstrip-index';
import {
  CurrentChangeDto,
  MobileEventModel,
  PlayerModel,
} from '@ay-gosu-party/server-shared';
import { asyncJob } from '@ay-gosu/ui/common/async-job';
import { Subscription } from 'rxjs';
import { INIT, MobileLoginService } from './login.service';

@Injectable({ providedIn: 'root' })
export class MobileService {
  public eventId = this._loginService.eventId;

  public event = asyncJob((eventId) => {
    if (!eventId) return null;

    return MobileEventModel.fetch(eventId);
  }, this.eventId);

  public modules = asyncJob((event) => {
    if (!event) return [];

    const modules: Module[] = [];
    for (const moduleRaw of event.modules) {
      const Module = getModule(moduleRaw.type);
      if (!Module) {
        console.error('No module found for type', moduleRaw.type);
        continue;
      }

      const module = new Module(moduleRaw);
      modules.push(module);
    }

    recalcFilmstripIndex(modules);
    return modules;
  }, this.event);

  public current = signal<{ module: Module; filmstrip: Filmstrip } | null>(
    null,
  );

  public subscription: Subscription | null = null;

  // 處理畫面轉換的訂閱
  public job = asyncJob(
    async (status, eventId, modules, token) => {
      if (status === INIT) {
        return undefined;
      }

      if (this.subscription) {
        this.subscription.unsubscribe();
        this.subscription = null;
      }

      if (!eventId || !modules) {
        throw new Error('No event id or modules');
      }

      const current = await PlayerModel.fetchCurrent(eventId);
      this._onCurrentChanged(current, modules);

      this.subscription = PlayerModel.listenCurrentChanged(eventId).subscribe(
        (current) => this._onCurrentChanged(current, modules),
      );
      return true;
    },
    this._loginService.status,
    this.eventId,
    this.modules,
    // 雖然這裡不會使用到 token，但為了讓斷線後頁面還能繼續跟著遊戲轉跳，所以需要傳入 token
    this._loginService.token,
  );

  public constructor(private readonly _loginService: MobileLoginService) {}

  public async refreshCurrent() {
    const eventId = this.eventId();
    if (!eventId) return;
    const current = await PlayerModel.fetchCurrent(eventId);
    this._onCurrentChanged(current, this.modules.data());
  }

  private _onCurrentChanged(current: CurrentChangeDto, modules: Module[]) {
    if (current.moduleUuid === undefined) {
      return;
    }

    const participant = this._loginService.participant();
    if (current.eventSessionId.toString() !== participant?.sessionId) {
      return;
    }

    for (const module of modules) {
      for (const filmstrip of module.filmstrips) {
        if (filmstrip.index === current.filmstripIndex) {
          this.current.set({ module, filmstrip });
          return;
        }
      }
    }
  }
}
